// extracted by mini-css-extract-plugin
export var dark = "styles-module--dark--d391d";
export var light = "styles-module--light--1b154";
export var scroll = "styles-module--scroll--5e79f";
export var wrapper = "styles-module--wrapper--2fb66";